export const SET_ALL_SECTIONS = "Setzt die Abschnitte einer Lieferung im Store";
export const SAVE_INTO_POSITION = "Fügt einen temporären Abschnitt ein";
export const REMOVE_FROM_POSITION = "Entfernt einen temporären Abschnitt";
